import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, watch } from 'vue';
import { useAddressLookupStore } from '@/store';
import { storeToRefs } from 'pinia';
import type { ISuburbLookupResult, IDropdownItem } from '@/interfaces';
import { toTitleCase } from '@/utils/convert';
import { SuburbLookupValueStyle } from '@/enums/suburb-lookup-types.enum';

// Define props and emitters
// ------------------------------------------------------------- //
interface Props {
  bindings: any;
  selectedSuburb: string;
  innerClass: string;
  labelClass: string;
  suburbLookupList?: ISuburbLookupResult[];
  suburbLookupValueStyle: SuburbLookupValueStyle;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SuburbLookupInput',
  props: {
    bindings: {},
    selectedSuburb: {},
    innerClass: {},
    labelClass: {},
    suburbLookupList: {},
    suburbLookupValueStyle: { default: SuburbLookupValueStyle.SuburbOnly }
  },
  emits: ['selected'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;

// Define Store
// ------------------------------------------------------------- //
const addressLookupStore = useAddressLookupStore();

// Define Composables
// ------------------------------------------------------------- //
const { riskSuburbsData } = storeToRefs(addressLookupStore);

// Define Component state
// ------------------------------------------------------------- //
const value = ref<string>(props.selectedSuburb);

// Lifecycle hooks
// ------------------------------------------------------------- //
watch(
  () => props.selectedSuburb,
  (newValue, oldValue) => {
    if (!oldValue && newValue) {
      value.value = newValue;
    }
  }
);

function filterLocations(searchTerm: string): ISuburbLookupResult[] {
  const lowerCaseTerm = searchTerm.toLowerCase();

  if (props.suburbLookupList && props.suburbLookupList.length > 0) {
    return props.suburbLookupList.filter(
      ({ postcode, suburb }) => postcode.toString() === lowerCaseTerm || suburb.toLowerCase() === lowerCaseTerm
    );
  }

  return [];
}

async function fetchSuburbsList({ search }: { search: string }): Promise<IDropdownItem[]> {
  try {
    if (!search || search.length < 3) return [];

    if (props.suburbLookupList) {
      addressLookupStore.setInsuranceRiskSuburbsLookup(filterLocations(search));
    } else {
      await addressLookupStore.getInsuranceRiskSuburbsLookup(search);
    }

    if (props.suburbLookupValueStyle === SuburbLookupValueStyle.SuburbAndPostcode) {
      return riskSuburbsData.value.map((item) => ({
        label: `${toTitleCase(item.suburb.toLowerCase())}, ${item.postcode}`,
        value: `${item.suburb}, ${item.postcode}`,
      }));
    } else {
      return riskSuburbsData.value.map((item) => ({
        label: `${toTitleCase(item.suburb.toLowerCase())}`,
        value: item.suburb,
      }));
    }
  } catch (error) {
    console.error('Unable to fetch suburbs list: ', error);
    return [];
  }
}

function handleSelection(suburb: string) {
  emit('selected', suburb);
}

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createBlock(_component_FormKit, _mergeProps(_ctx.bindings, {
    modelValue: value.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
    options: fetchSuburbsList,
    messagesClass: "max-sm:ml-0",
    innerClass: _ctx.bindings.innerClass || _ctx.innerClass,
    labelClass: _ctx.labelClass,
    selectIconClass: "hidden",
    maxLength: "100",
    onInput: handleSelection
  }), null, 16, ["modelValue", "innerClass", "labelClass"]))
}
}

})